import { render, staticRenderFns } from "./CompanyCost.vue?vue&type=template&id=40c2d55a&scoped=true"
import script from "./CompanyCost.vue?vue&type=script&lang=js"
export * from "./CompanyCost.vue?vue&type=script&lang=js"
import style0 from "./CompanyCost.vue?vue&type=style&index=0&id=40c2d55a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c2d55a",
  null
  
)

export default component.exports